var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Hero',{attrs:{"experiencesYPos":_vm.experiencesYPos}}),_c('Introduction'),_c('Experiences',{on:{"ready":function($event){return _vm.onComponentReady($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }